<button type="button" class="social-btn" (click)="btnClick.emit()">
  <img src="/assets/icons/google-icon.svg" alt="Google" />
  {{ label() }}
</button>
